import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Registrazione completata");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 px-4 grid-lines">
      <div className="w-full max-w-md border border-white/10 bg-zinc-900/70 backdrop-blur p-8">
        <div className="font-mono-data text-xs text-lime-400 tracking-widest mb-2">— NUOVO ACCOUNT</div>
        <h1 className="font-display font-black text-3xl mb-6">Attiva il tuo terminale.</h1>

        <form onSubmit={submit} className="space-y-5" data-testid="register-form">
          <div className="space-y-2">
            <Label htmlFor="name" className="font-mono-data text-xs tracking-widest text-zinc-400">NOME</Label>
            <Input
              id="name" value={name} onChange={(e) => setName(e.target.value)} required
              className="rounded-none bg-zinc-950 border-white/10 focus:border-lime-400 focus:ring-1 focus:ring-lime-400 h-11"
              data-testid="input-name"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email" className="font-mono-data text-xs tracking-widest text-zinc-400">EMAIL</Label>
            <Input
              id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="rounded-none bg-zinc-950 border-white/10 focus:border-lime-400 focus:ring-1 focus:ring-lime-400 h-11"
              data-testid="input-email"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="font-mono-data text-xs tracking-widest text-zinc-400">PASSWORD <span className="text-zinc-600">(min 6)</span></Label>
            <Input
              id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
              className="rounded-none bg-zinc-950 border-white/10 focus:border-lime-400 focus:ring-1 focus:ring-lime-400 h-11"
              data-testid="input-password"
            />
          </div>
          {error && (
            <div className="border border-red-500/40 bg-red-500/10 text-red-300 text-sm p-3 font-mono-data" data-testid="register-error">
              {error}
            </div>
          )}
          <Button
            type="submit" disabled={busy}
            className="w-full rounded-none bg-lime-400 text-lime-950 hover:bg-lime-500 font-bold h-11"
            data-testid="btn-register-submit"
          >
            {busy ? "Creazione in corso..." : "Crea account →"}
          </Button>
        </form>

        <div className="mt-6 text-sm text-zinc-500 text-center">
          Hai già un account? {" "}
          <Link to="/login" className="text-lime-400 hover:underline" data-testid="link-login">
            Accedi
          </Link>
        </div>
      </div>
    </div>
  );
}
